export const LeftArrow = () => {
    return <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0.3 4L4.3 8L5 7.3L1.71 4L5 0.7L4.3 0L0.3 4Z" fill="#1F1F1F" />
    </svg>

}